import { render, staticRenderFns } from "./TheSimonGame.container.vue?vue&type=template&id=2294680d&scoped=true&"
import script from "./TheSimonGame.container.vue?vue&type=script&lang=js&"
export * from "./TheSimonGame.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2294680d",
  null
  
)

export default component.exports